export const config = {
  projectId: process.env.GATSBY_PROJECT_ID ? `${process.env.GATSBY_PROJECT_ID}` : `${process.env.STORYBOOK_PROJECT_ID}`,
  dataset: process.env.GATSBY_DATASET ? `${process.env.GATSBY_DATASET}` : `${process.env.STORYBOOK_DATASET}`,
}
